module.exports = require("redux-thunk");